var _circle, _circle2, _g, _circle3, _circle4, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.485 35.117c0-2.909-1.745-3.906-5.236-4.321-2.493-.333-2.991-.998-2.991-2.161 0-1.164.83-1.912 2.493-1.912 1.496 0 2.327.499 2.742 1.745.084.25.333.416.582.416h1.33c.332 0 .582-.25.582-.582v-.083a4.152 4.152 0 0 0-3.74-3.407v-1.995c0-.332-.25-.582-.665-.665h-1.247c-.332 0-.582.25-.665.665v1.912c-2.493.332-4.072 1.994-4.072 4.072 0 2.743 1.662 3.823 5.153 4.238 2.327.416 3.075.915 3.075 2.244 0 1.33-1.164 2.244-2.743 2.244-2.16 0-2.909-.914-3.158-2.16-.083-.333-.332-.5-.582-.5H26.93a.568.568 0 0 0-.581.583v.083c.332 2.077 1.662 3.573 4.404 3.989v1.995c0 .332.25.581.665.664h1.247c.332 0 .582-.25.665-.664v-1.995c2.493-.416 4.155-2.161 4.155-4.405Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.762 43.843c-6.483-2.327-9.807-9.557-7.397-15.956 1.247-3.49 3.99-6.15 7.397-7.397.332-.166.498-.415.498-.831v-1.163c0-.333-.166-.582-.498-.665-.084 0-.25 0-.333.083-7.895 2.493-12.217 10.887-9.723 18.782a14.95 14.95 0 0 0 9.723 9.724c.333.166.665 0 .748-.333.083-.083.083-.166.083-.332V44.59c0-.25-.249-.581-.498-.748Zm8.81-25.93c-.333-.165-.666 0-.749.333-.083.083-.083.166-.083.333v1.163c0 .333.25.665.499.831 6.482 2.327 9.806 9.558 7.396 15.957-1.246 3.49-3.989 6.15-7.396 7.396-.333.167-.499.416-.499.832v1.163c0 .333.166.582.499.665.083 0 .249 0 .332-.083 7.895-2.493 12.217-10.887 9.724-18.782-1.496-4.738-5.153-8.311-9.724-9.807Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVUsdc);
export default __webpack_public_path__ + "static/media/vUsdc.30a2d2d4c8a972e5f2db4c00d18589fa.svg";
export { ForwardRef as ReactComponent };